import { usePress } from "@react-aria/interactions";
import { filterDOMProps, mergeProps } from "@react-aria/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/**
 * Provides the behavior and accessibility implementation for a link component.
 * A link allows a user to navigate to another page or resource within a web page
 * or application.
 */

export function useLink(props, ref) {
  var _props$elementType = props.elementType,
      elementType = _props$elementType === void 0 ? 'a' : _props$elementType,
      onPress = props.onPress,
      onPressStart = props.onPressStart,
      onPressEnd = props.onPressEnd,
      deprecatedOnClick = props.onClick,
      isDisabled = props.isDisabled,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["elementType", "onPress", "onPressStart", "onPressEnd", "onClick", "isDisabled"]);

  var linkProps;

  if (elementType !== 'a') {
    linkProps = {
      role: 'link',
      tabIndex: !isDisabled ? 0 : undefined
    };
  }

  var _usePress = usePress({
    onPress: onPress,
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    isDisabled: isDisabled,
    ref: ref
  }),
      pressProps = _usePress.pressProps;

  var domProps = filterDOMProps(otherProps, {
    labelable: true
  });
  return {
    linkProps: mergeProps(domProps, _babelRuntimeHelpersEsmExtends({}, pressProps, linkProps, {
      'aria-disabled': isDisabled || undefined,
      onClick: function onClick(e) {
        pressProps.onClick(e);

        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    }))
  };
}